export const hotelDraft: string = `
<h3>ホテルのコンセプトやオープンまでのストーリーは？</h3>
<blockquote><p>コンセプトの紹介や、オープンまでのストーリーを紹介するセクションです。ホテルのコンセプトは見出しとして入れましょう。</p></blockquote>

<h3>「不便を贅沢に愉しむ」</h3>
<p>(例)2008年8月、人里離れた鳥取県磯崎市の山間で長らく手付かずだった朽ち果てた民家を地元のクリエイターとともに手を加えて、ひっそりと隠れるように過ごせる宿にしました。
<br>ここには都会の生活のような便利さはありません。
<br>ただ、都会の暮らしでは味わえない、どこか懐かしく、ゆったりとした贅沢な時間をお愉しみいただけます。</p>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955573362.jpg">(コンセプトの世界観を訴求する写真を1-3枚入れましょう)</h6>


<h3>ホテルの魅力は？</h3>
<blockquote><p>ホテルならではの体験を表現しましょう。魅力を端的に表す言葉を見出しにして、記載する内容はできる限り部屋やプランとは別にしましょう。</p></blockquote>

<h3>「四季に魅了される」</h3>
<p>(例)HOTEL ABCでは、訪れるたびに別の顔をした空間がゲストをお出迎えします。
<br>春には新緑、
<br>夏には涼やかな山の風と鳥の鳴き声、
<br>秋には赤々とした山々の紅葉、
<br>冬には極寒の銀世界と星空。
<br>地元で採れる四季折々の旬のものと合わせて、HOTEL ABCでしか味わえない時間を満喫ください。</p>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955722606.jpg"></h6>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955751955.jpg">(体験を表現する写真を1-2枚入れましょう)</h6>


<h3>ここでしかできないユニークな体験は？</h3>
<blockquote><p>このホテルならではの体験を訴求しましょう。体験を端的に表す言葉を見出しにして、できる限り部屋やプランとは別の内容を記載しましょう。</p></blockquote>

<h3>「こころを整える時間」</h3>
<p>(例)磯崎にはかつて古書店が並び、多くの文豪たちも訪れた文学の町でした。
<br>そんな町の歴史も踏まえて、不便さが故にできる体験を提供したいと想いから、様々なジャンルの本が揃うバーライブラリーをご用意しております。
<br>お好きなお飲み物を片手に本を読み耽るようにお過ごしいただけます。</p>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955694623.jpeg">(体験を表現する写真を1-2枚入れましょう)</h6>



<h3>地域の魅力は？</h3>
<blockquote><p>ホテルが位置する地域の魅力を訴求しましょう。魅力を端的に表す言葉を見出しにしましょう。観光ガイドに掲載されていないホテルスタッフだから知っているような周辺地域の魅力を記載すると素敵な記事になります</p></blockquote>

<h3>「磯崎タイムワープ」</h3>
<p>(例)磯崎にはガイドラインには掲載されていない古くて新しい魅力的な場所やお店が点在しています。
<br><strong>D商店</strong>
<br>昔から変わらない出汁を使った温かくて優しいうどんはお昼ご飯におすすめです。</p>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955667799.jpeg">(写真を1-2枚入れましょう)</h6>
<br>
<p><strong>Eスタンド</strong>
<br>都会のお店には卸していない地酒をコの字型のカウンターで地元の方々と楽しむことができます。</p>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955651286.jpeg">(写真を1-2枚入れましょう)</h6>
<br>
<br>
<br>
<p>ゲストの滞在がより豊かになるようにHOTEL ABCのスタッフがコンシェルジェとして旅の相談に乗らせていただきます。
<br>それではHOTEL ABCへのご来館を心よりお待ちしております。</p>`;
